import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AppShell from "@/components/AppShell";
import Brief from "@/pages/Brief";
import Assistant from "@/pages/Assistant";
import Memoire from "@/pages/Memoire";
import PassportDetail from "@/pages/PassportDetail";
import Vehicules from "@/pages/Vehicules";
import Documents from "@/pages/Documents";
import Garanties from "@/pages/Garanties";
import Recherche from "@/pages/Recherche";
import Confidentialite from "@/pages/Confidentialite";
import Business from "@/pages/Business";
import BusinessShell from "@/components/BusinessShell";
import BusinessDashboard from "@/pages/business/BusinessDashboard";
import BusinessCatalogue from "@/pages/business/BusinessCatalogue";
import BusinessClaims from "@/pages/business/BusinessClaims";
import Inbox from "@/pages/Inbox";
import Foyer from "@/pages/Foyer";
import Sante from "@/pages/Sante";
import GiftLists from "@/pages/Cadeaux";
import SharedGiftList from "@/pages/CadeauxPartage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Chargement…</div>;
  if (!user) return <Navigate to="/connexion" replace />;
  return children;
}

function App() {
  return (
    <div className="App omy-grain">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/connexion" element={<Auth />} />
            <Route path="/cadeaux/:token" element={<SharedGiftList />} />
            <Route path="/app" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Brief />} />
              <Route path="assistant" element={<Assistant />} />
              <Route path="memoire" element={<Memoire />} />
              <Route path="memoire/:id" element={<PassportDetail />} />
              <Route path="vehicules" element={<Vehicules />} />
              <Route path="documents" element={<Documents />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="garanties" element={<Garanties />} />
              <Route path="sante" element={<Sante />} />
              <Route path="foyer" element={<Foyer />} />
              <Route path="recherche" element={<Recherche />} />
              <Route path="confidentialite" element={<Confidentialite />} />
              <Route path="business" element={<Business />} />
              <Route path="cadeaux" element={<GiftLists />} />
            </Route>
            <Route path="/business-app" element={<Protected><BusinessShell /></Protected>}>
              <Route index element={<BusinessDashboard />} />
              <Route path="catalogue" element={<BusinessCatalogue />} />
              <Route path="revendications" element={<BusinessClaims />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
